// extracted by mini-css-extract-plugin
export default {"onboardingVideoPopup":"OnboardingVideo_onboardingVideoPopup__CI8R8","videoSection":"OnboardingVideo_videoSection__ilPUf","bottomButtons":"OnboardingVideo_bottomButtons__aKONQ"};